import { autoinject, bindable, bindingMode } from 'aurelia-framework';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { BaseCustomElement } from 'Common/BaseCustomElement';

@autoinject
export class StarRatingBaseCustomElement extends BaseCustomElement {
    @bindable({ defaultBindingMode: bindingMode.toView }) editable: boolean = true;
}